"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var node_content_renderer_1 = require("./node-content-renderer");
var tree_node_renderer_1 = require("./tree-node-renderer");
var theme = function (props) { return ({
    nodeContentRenderer: (0, node_content_renderer_1.default)(props),
    treeNodeRenderer: (0, tree_node_renderer_1.default)(props),
    scaffoldBlockPxWidth: 24,
    slideRegionSize: 50
}); };
exports.default = theme;
